import { jsx as _jsx } from "react/jsx-runtime";
const Status = ({ status }) => {
    return (_jsx("span", { className: `status-badge ${status ? "on" : "off"}`, children: status ? "✓" : "✕" }));
};
export default Status;
